import React, {Dispatch, SetStateAction} from "react";
import Button from "@awsui/components-react/button";
import {useMutation} from "react-query";
import {FlashbarProps} from "@awsui/components-react/flashbar/interfaces";
import createRiders from "api/createRiders";
import NewRider from "model/admin/NewRider";
import {useAuth} from "hooks/useAuth";


interface AddRiderButtonProps {
    rider: NewRider;
    setRider: Dispatch<SetStateAction<NewRider>>;
    buttonEnabled: boolean;
    setButtonEnabled: Dispatch<SetStateAction<boolean>>;
    setSubmitMessage: Dispatch<SetStateAction<FlashbarProps.MessageDefinition | undefined>>;
}

const AddRiderButton: React.FC<AddRiderButtonProps> = (props) => {

    const rider = props.rider;

    const [{user}] = useAuth();

    const {
        mutate: addRiderMutation,
        isLoading: addRiderIsLoading
    } = useMutation((rider: NewRider) => createRiders([rider], user?.token), {
            onSuccess: (riderIds: number[]) => {
                // The endpoint is idempotent by name, so a success here doesn't
                // necessarily mean a row was inserted. Showing the id lets the
                // admin spot that a resubmit returned the pre-existing rider.
                props.setSubmitMessage({
                    header: "Rider added correctly",
                    type: "success",
                    content: `Rider id: ${riderIds[0]}`,
                })
            },
            onError: () => {
                props.setSubmitMessage({
                    header: "Error when adding rider",
                    type: "error",
                    content: "Try to refresh the page.",
                })
            },
            onSettled: () => {
                props.setButtonEnabled(false);
                props.setRider({});
            }
        }
    );

    return (
        <Button
            disabled={!props.buttonEnabled || !rider.name?.trim()}
            iconAlign="left"
            loading={addRiderIsLoading}
            variant="primary"
            onClick={() => addRiderMutation(rider)}
        >
            Submit
        </Button>
    );
};

export default AddRiderButton;
